import { CSSProperties, FC } from 'react';

import { Icon, IconButton } from '@atom/mui';
import fonts from '@atom/styles/fonts';

import { useChatContext } from './ChatContext';

import classes from './chat.module.css';

const styles: Record<string, CSSProperties> = {
  icon: {
    fontSize: fonts.xxxl,
  },
};

const ChatHeader: FC = () => {
  const {
    ui: { chatExpanded, toggleChatExpanded, toggleChatOpen },
  } = useChatContext();

  const handleClose = () => {
    toggleChatOpen();
  };

  return (
    <div className={classes.headerRoot}>
      <div className={classes.headerTitleContainer}>
        <div className={classes.headerTitleRow}>
          <span className={classes.headerTitle}>Atom AI</span>
          <div className={classes.headerBetaLabel}>
            <span className={classes.headerBetaText}>BETA</span>
          </div>
        </div>
      </div>
      <IconButton
        onClick={toggleChatExpanded}
        size="small"
        tooltip={chatExpanded ? 'Collapse' : 'Expand'}
      >
        <Icon style={styles.icon}>
          {chatExpanded ? 'fullscreen_exit' : 'fullscreen'}
        </Icon>
      </IconButton>
      <IconButton onClick={handleClose} size="small" tooltip="Close">
        <Icon style={styles.icon}>close</Icon>
      </IconButton>
    </div>
  );
};

export default ChatHeader;
